export function someGetter(state) {}